
import React, { useRef, useState, useContext, useEffect } from 'react';
import {
  getAuth,
  createUserWithEmailAndPassword,
  sendEmailVerification,
  updateProfile,
  multiFactor
} from 'firebase/auth';
import { getFirestore, updateDoc, doc, getDoc, setDoc, arrayUnion } from 'firebase/firestore';
import { getDatabase, ref, set } from 'firebase/database';
import { useNavigate } from 'react-router-dom';
import { AppContext } from './AppContext';
import Select from 'react-select';

const CustomCheckbox = ({ isChecked, onCheck }) => {
  return (
      <div onClick={onCheck} style={styles.checkboxBase}>
          {isChecked && <div style={styles.checkboxChecked} />}
      </div>
  );
};


const SignupScreen = ({ setShowMFAPrompt, onSwitchToLogin, onSuccessfulSignup }) => {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [name, setName] = useState('');
  const [username, setUsername] = useState('');
  const [accountType, setAccountType] = useState('Fan');
  const [validationError, setValidationError] = useState('');
  const [location, setLocation] = useState('');
const [isSigningUp, setIsSigningUp] = useState(false);
  const [selectedState, setSelectedState] = useState('');
  const [country, setCountry] = useState(null); 
  const [confirmPassword, setConfirmPassword] = useState('');

  const [namePlaceholder, setNamePlaceholder] = useState('Artist Name');
  const [termsModalVisible, setTermsModalVisible] = useState(false);
  const [termsAccepted, setTermsAccepted] = useState(false);

  const [showVerifyPrompt, setShowVerifyPrompt] = useState(false);

  const passwordRef = useRef(null);
  const confirmPasswordRef = useRef(null);

  useEffect(() => {
    switch (accountType) {
      case 'Artist':
        setNamePlaceholder('Artist Name');
        break;
      case 'Producer':
        setNamePlaceholder('Producer Name');
        break;
      case 'RecordLabel':
        setNamePlaceholder('Record Label Name');
        break;
      case 'Songwriter':
        setNamePlaceholder('Songwriter Name');
        break;
      case 'SPNCaster':
        setNamePlaceholder('SPNCaster Name');
        break;
      case 'Fan':
        setNamePlaceholder('Name');
        break;
      case 'Band':
        setNamePlaceholder('Band Name');
        break;
      default:
        setNamePlaceholder('Name');
    }
  }, [accountType]);

  const auth = getAuth();
  const firestore = getFirestore();
  const database = getDatabase();

  const { setUser } = useContext(AppContext);



  const statesList = [
    { label: 'Alabama', value: 'AL' },
    { label: 'Alaska', value: 'AK' },
    { label: 'Arizona', value: 'AZ' },
    { label: 'Arkansas', value: 'AR' },
    { label: 'California', value: 'CA' },
    { label: 'Colorado', value: 'CO' },
    { label: 'Connecticut', value: 'CT' },
    { label: 'Delaware', value: 'DE' },
    { label: 'Florida', value: 'FL' },
    { label: 'Georgia', value: 'GA' },
    { label: 'Hawaii', value: 'HI' },
    { label: 'Idaho', value: 'ID' },
    { label: 'Illinois', value: 'IL' },
    { label: 'Indiana', value: 'IN' },
    { label: 'Iowa', value: 'IA' },
    { label: 'Kansas', value: 'KS' },
    { label: 'Kentucky', value: 'KY' },
    { label: 'Louisiana', value: 'LA' },
    { label: 'Maine', value: 'ME' },
    { label: 'Maryland', value: 'MD' },
    { label: 'Massachusetts', value: 'MA' },
    { label: 'Michigan', value: 'MI' },
    { label: 'Minnesota', value: 'MN' },
    { label: 'Mississippi', value: 'MS' },
    { label: 'Missouri', value: 'MO' },
    { label: 'Montana', value: 'MT' },
    { label: 'Nebraska', value: 'NE' },
    { label: 'Nevada', value: 'NV' },
    { label: 'New Hampshire', value: 'NH' },
    { label: 'New Jersey', value: 'NJ' },
    { label: 'New Mexico', value: 'NM' },
    { label: 'New York', value: 'NY' },
    { label: 'North Carolina', value: 'NC' },
    { label: 'North Dakota', value: 'ND' },
    { label: 'Ohio', value: 'OH' },
    { label: 'Oklahoma', value: 'OK' },
    { label: 'Oregon', value: 'OR' },
    { label: 'Pennsylvania', value: 'PA' },
    { label: 'Rhode Island', value: 'RI' },
    { label: 'South Carolina', value: 'SC' },
    { label: 'South Dakota', value: 'SD' },
    { label: 'Tennessee', value: 'TN' },
    { label: 'Texas', value: 'TX' },
    { label: 'Utah', value: 'UT' },
    { label: 'Vermont', value: 'VT' },
    { label: 'Virginia', value: 'VA' },
    { label: 'Washington', value: 'WA' },
    { label: 'West Virginia', value: 'WV' },
    { label: 'Wisconsin', value: 'WI' },
    { label: 'Wyoming', value: 'WY' }
  ];

  const countryList = [
    { label: 'United States', value: 'US' },
    { label: 'United Kingdom', value: 'UK' },
    { label: 'Canada', value: 'CA' },
    { label: 'Australia', value: 'AU' },
    { label: 'Germany', value: 'DE' },
    { label: 'Sweden', value: 'SE' },
    { label: 'France', value: 'FR' },
    { label: 'Brazil', value: 'BR' },
    { label: 'Japan', value: 'JP' },
    { label: 'Netherlands', value: 'NL' }
  ];

  const handleSignupPress = async () => {
    setTermsModalVisible(true);
  };

const handleAgreeAndCreateAccount = async () => {
  if (!termsAccepted) {
    setValidationError('You must accept the Terms and Conditions to create an account.');
    return;
  }

  const blockedDomains = ['maskmsn.cc', 'masn.com'];
  const emailDomain = email.split('@')[1]?.toLowerCase();
  if (blockedDomains.includes(emailDomain)) {
    setValidationError('This email domain is not allowed.');
    return;
  }

  setValidationError('');
  setIsSigningUp(true);

  if (!email || !password || !confirmPassword || !username || !name) {
    setValidationError('Please fill in all mandatory fields.');
    setIsSigningUp(false);
    return;
  }

  if (!/^\S+@\S+\.\S+$/.test(email)) {
    setValidationError('Invalid email format.');
    setIsSigningUp(false);
    return;
  }

  if (password !== confirmPassword) {
    setValidationError('Passwords do not match.');
    setIsSigningUp(false);
    return;
  }

  if (name.length > 30 || username.length > 30) {
    setValidationError('Name and username must be less than 30 characters.');
    setIsSigningUp(false);
    return;
  }

  try {
    const userCredential = await createUserWithEmailAndPassword(auth, email, password);
    const user = userCredential.user;

    // 1) Update profile while signed in
    try {
      await updateProfile(user, { displayName: username });
    } catch (e) {
      // Non-fatal; continue but log it
      console.warn('updateProfile failed:', e?.message || e);
    }

    // 2) Reserve username (fail fast if taken)
    const usernameLowerCase = username.toLowerCase();
    const usernameRef = doc(firestore, 'usernames', usernameLowerCase);
    const usernameSnapshot = await getDoc(usernameRef);
    if (usernameSnapshot.exists()) {
      setValidationError('Username already taken');
      setIsSigningUp(false);
      return;
    }
    await setDoc(usernameRef, { uid: user.uid });

    // 3) Create Firestore user doc (still signed in)
const mandatoryFollowingIds = [
  "h0fEIStkM4XHTDErZM5i8XIo9rA3",
  "OHaY20b54nTGd5BBgbJOL2BHEbX2",
  "rdX289s3YBP31Hw5qn2eXVywtBq1",
  "Mkf4631LCEOYmHXWRzGirPdxBrt1"
];
    const userState = country === 'US' ? selectedState : country;

    const firestoreUserData = {
      id: user.uid,
      userId: user.uid,
      email,
      name,
      ArtistName: name,
      ArtistNameLower: name.toLowerCase(),
      username,
      username_lower: usernameLowerCase,
      location,
      accountType,
      profileImageUrl: '',
      lastOperationTime: new Date(),
      purchaseHistory: [],
      salesHistory: [],
      uploadedItems: [],
      purchasedItems: [],
      streamedSongs: [],
      streamedVideos: [],
      state: userState,
      following: [...mandatoryFollowingIds],
      purchasedMedia: [],
      ScreenSKN: [],
      ScreenSKNpurchased: [],
      ...(accountType !== 'Fan' && {
        albums: [],
        singles: [],
        videos: [],
        videoalbums: [],
      }),
    };

    await setDoc(doc(firestore, 'users', user.uid), firestoreUserData);

    // 4) Seed RTDB (still signed in)
    await set(ref(database, `users/${user.uid}/credits`), 0);
    await set(ref(database, `users/${user.uid}/stats`), {
      totalSpns: 0,
      sales: { singles: 0, albums: 0, videos: 0 },
    });

    // 5) Add this user to followers of mandatory accounts (still signed in)
    await Promise.all(
      mandatoryFollowingIds.map(id =>
        updateDoc(doc(firestore, 'users', id), { followers: arrayUnion(user.uid) })
      )
    );

    // 6) Send verification email while still signed in, then sign out
    await sendEmailVerification(user, { url: 'https://spndat.com/login' });
    await auth.signOut();

    // 7) Show local state and route with banner
    setShowVerifyPrompt(true);
    setIsSigningUp(false);
    navigate('/login', { state: { showVerifyBanner: true, email } });
  } catch (error) {
    console.error('Signup error:', error);
    setValidationError(error.message || 'Signup failed');
    setIsSigningUp(false);
  }
};


  const CustomButton = ({ onClick, title, textStyle, buttonStyle }) => (
    <button onClick={onClick} style={{ ...styles.customButton, ...buttonStyle }}>
      <span style={{ ...styles.customButtonText, ...textStyle }}>
        {title}
      </span>
    </button>
  );

  useEffect(() => {
    
  }, [accountType]);

  useEffect(() => {
    
  }, [username]);

  const DISPLAY_TEXT =   "TERMS OF SERVICE\n" +
"SPNDAT INC.\n\n" +

"These Terms of Service (the \"Terms\") govern your access to use the SPNDAT social media platform, including all features, functionalities, and services (collectively, the \"Service\") and your use of your use of the music and video jukebox component of the software application (the \"App\") offered by SPNDAT, Inc. (\"SPNDAT\", \"us\" or \"we\"). By accessing or using the App and/or the Service, you (\"you\" or the \"user\") agree to be bound by these Terms, our Privacy Policy, and the DatChain Terms of Use.\n\n" +

"1. Your Account\n" +
"   a. You may be required to create an account to use certain features of the App and/or Service.\n" +
"   b. Use of the App. The App allows you to play and purchase music and video, as well as listen to free music provided by the App's library. You may use the App for personal or commercial purposes. You may not use the App for any illegal or unauthorized purpose.\n" +
"   c. Use of the Service. The Service allows you to send messages, post content, and follow other users. You are solely responsible for the content of your messages and posts (\"User Content\"). You agree not to post or send any content that is illegal, harmful, threatening, abusive, harassing, defamatory, vulgar, obscene, libelous, invasive of another's privacy, hateful, or racially, ethnically, or otherwise objectionable. You agree not to engage in any activity that interferes with or disrupts the Service, including the servers and networks connected to the Service.\n" +
"   d. Account Requirements. By using the App and/or Service, you represent and agree to the following conditions and requirements:\n" +
"      i. You must be at least 13 years old to use the App and/or Service. By creating an account, you represent that you are at least 13 years old and have the legal capacity to enter into these Terms.\n" +
"      ii. You are responsible for maintaining the confidentiality of your account and your password and for restricting access to your account.\n" +
"      iii. You agree to accept sole responsibility and liability for all activities that occur under your account.\n" +
"      iv. You agree to provide accurate, current, and complete information during the registration process and to update such information to keep it accurate, current, and complete.\n" +
"      v. You agree not to use the Service for any illegal or unauthorized purpose.\n" +
"   e. Account Types. SPNDAT offers multiple types of accounts, including User Accounts and Vendor Accounts. By creating or using a User Account or Vendor Account, you agree to the following:\n" +
"      i. User Accounts. We may offer, in our sole discretion, for you to create, access, and use a User Account. User Accounts are authorized to send messages, post content, and follow other users. User Accounts are further authorized to access Vendor Content (defined herein) only in accordance with these Terms and other requirements put in place by Vendor Account owners.\n" +
"      ii. Vendor Accounts. We may offer, in our sole discretion, for you to create and use a Vendor Account. Vendor Accounts are authorized to provide sound recordings, music videos, musical performances, and other intellectual property (\"Vendor Content\") for distribution and commercial exploitation through the App. Vendor accounts shall include any Artist, SPNcaster, Producer, DJ, and record label accounts. All SPNDAT vendor accounts are charged a 30% fee on all financial transactions throughout the app. SPNDAT is not responsible for any reimbursements to you; all sales and transactions are final. By providing any Vendor Content to SPNDAT, you assert and affirm that you are the owner of the Vendor Content or otherwise authorized to license the Vendor Content in accordance with these Terms.\n\n" +

"2. Intellectual Property\n" +
"   a. Our Intellectual Property. The App and/or Service and its original content, features, and functionality are owned by SPNDAT INC. and are protected by copyright, trademark, and other intellectual property laws. You agree not to reproduce, distribute, modify, create derivative works of, publicly display, publicly perform, republish, download, store, or transmit any of the material on the App and/or Service, except as necessary for your own personal, non-commercial use. SPNDAT has the right to remove any User Content or Vendor Content provided to the app unlawfully for any reason, without notice.\n" +
"   b. User Content. You hereby grant to SPNDAT a license to reproduce, distribute, modify, create derivative works of, publicly display, publicly perform, republish, download, store, or transmit any of the User Content that you provide to SPNDAT via the Service without limitation.\n" +
"   c. Vendor’s Content. You understand and acknowledge that any music or other intellectual property made available on the App by Vendor Account holders is subject to copyright protection. Any account that is not a Vendor Account may only use Vendor Content for personal, non-commercial purposes, as provided in the context of the App. You agree not to modify, reproduce, distribute, transmit, display, perform, or create derivative works from any Vendor Content without the express permission of the copyright owner, and hold SPNDAT INC. harmless against any content or copyright infringements. You are solely responsible, and SPNDAT is explicitly not responsible, for any royalties, licenses, agreements, or claims associated with the provided Vendor Content.\n" +
"   d. Copyright Complaint Notice. Any party who believes that their work has been copied in a way that constitutes copyright infringement should notify us of their infringement claim in accordance with the procedure set forth herein. We will process and investigate notices of alleged infringement and take appropriate actions under the Digital Millennium Copyright Act (\"DMCA\") with respect to any alleged or actual infringement. A notification of claimed copyright infringement should be emailed to the following address with the subject line \"DMCA Takedown Request\":\n" +
"\n" +
"SPNDAT Inc.’s Copyright Agent\n" +
"support@spndat.com\n" +
"2025 S McCall Road,\n" +
"Englewood, FL 34223\n" +
"\n" +
"      i. Notification Requirements. To be effective, the notification must be in writing and contain the following information:\n" +
"         1. A physical or electronic signature of a person authorized to act on behalf of the owner of the copyright or other intellectual property interest that is allegedly infringed;\n" +
"         2. Identification of the copyrighted work or other intellectual property that you claim has been infringed, or, if multiple copyrighted works are covered by a single notification, a list identifying such works or other intellectual property;\n" +
"         3. Identification of the content that is claimed to be infringing or to be the subject of infringing activity, including where the content that is claimed to be infringing is located, with sufficient detail that SPNDAT may locate it;\n" +
"         4. The notifying party’s address, telephone number, and email address; and\n" +
"         5. A statement affirming good faith belief that the disputed use is not authorized by the copyright or intellectual property owner, its agent, or the law; that the information in your notice is accurate and, under penalty of perjury, that the notifying party is the copyright or intellectual property owner or is authorized to act on the behalf of the owner of the copyright or intellectual property that is allegedly infringed.\n" +
"      ii. Counter-Notice. If a party believes that their content that was removed (or to which access was disabled) is not infringing, or that they have the authorization from the copyright owner, from the copyright owner's agent, or pursuant to the law, to upload and use the intellectual property in content, such party may send a written counter-notice containing the following information to the Copyright Agent:\n" +
"         • The party’s physical or electronic signature;\n" +
"         • Identification of the content that has been removed or to which access has been disabled, including the location at which the content appeared before it was removed or disabled;\n" +
"         • A statement by the party, made under penalty of perjury, affirming they have a good faith belief that the content was removed or disabled as a result of mistake or a misidentification of the content to be removed or disabled;\n" +
"         • The party’s name, address, telephone number, and email address; and\n" +
"         • A statement consenting to the jurisdiction of the federal court located within Tennessee and a statement that the party will accept service of process from the person who provided notification of the alleged infringement.\n" +
"      iii. If a counter-notice is received by the Copyright Agent, SPNDAT will send a copy of the counter-notice to the original complaining party informing them that SPNDAT may replace the removed content or cease disabling it within ten (10) business days. Unless the owner of the applicable copyrighted work files an action seeking a court order against SPNDAT or the user, the removed content may be replaced, or access to it restored, within ten (10) to fourteen (14) business days or more after receipt of the counter-notice, at SPNDAT’s sole discretion.\n" +
"      iv. Repeat Infringement. In accordance with the DMCA and other applicable law, we may, at our sole discretion, terminate the accounts of users deemed to be repeat infringers. We may also, in our sole discretion, limit access to the Service and/or terminate the accounts of any users who infringe any intellectual property rights of others, whether or not there is any repeat infringement.\n\n" +

"3. Prohibited Conduct. You agree not to use the App in any way that violates any applicable laws or regulations. You agree not to use the App to transmit any content that is illegal, harmful, threatening, abusive, harassing, defamatory, vulgar, obscene, libelous, invasive of another's privacy, hateful, or racially, ethnically, or otherwise objectionable.\n\n" +

"4. Termination. We reserve the right to terminate or suspend your account and access to the App and/or Service at any time and for any reason, without notice.\n\n" +

"5. Governing Law. These Terms shall be governed by and construed in accordance with the laws of the state of Tennessee, without regard to its conflict of law principles.\n\n" +

"6. Changes to Terms. We reserve the right to modify or revise these Terms at any time. We will notify you of any changes by posting the new Terms for the App and/or Service.\n\n" +

"7. Disclaimers. By choosing to follow users of the SPNDAT platform, you are allowing those you follow to send you direct marketing info which include but are not limited to, direct messages, images, special offers and promotions. You can opt out of receiving information from any user on the SPNDAT platform by simply unfollowing that user and/or content provider. In addition, if at any point you have received content that you deem inappropriate or a violation of these Terms, you agree to report this violation to SPNDAT using the report tool. By deactivating an account, all data associated with that account will be lost. This includes but is not limited to personal information and unclaimed money.\n\n" +

"8. Disclaimer of Warranty. The App is provided \"as is\" and \"as available\" without warranties of any kind, either express or implied, including, but not limited to, the implied warranties of merchantability, fitness for a particular purpose, or non-infringement.\n\n" +

"9. Limitation of Liability; Waiver of Jury Trial. EXCEPT FOR EACH PARTY’S INDEMNIFICATION OBLIGATIONS HEREUNDER, NEITHER PARTY WILL BE LIABLE TO THE OTHER PARTY FOR ANY SPECIAL, INDIRECT, CONSEQUENTIAL, EXEMPLARY, PUNITIVE OR INCIDENTAL DAMAGES WHATSOEVER (INCLUDING LOST RIGHTS, PROFITS OR GOODWILL, BUSINESS INTERRUPTION, REPUTATIONAL DAMAGE AND THE LIKE) ARISING OUT OF OR IN CONNECTION WITH THE PERFORMANCE, NON-PERFORMANCE OR BREACH OF THIS AGREEMENT.\n\n" +
"EACH PARTY ACKNOWLEDGES AND AGREES THAT ANY DISPUTE RELATING TO OR ARISING OUT OF THIS AGREEMENT IS LIKELY TO INVOLVE COMPLICATED AND DIFFICULT ISSUES, AND THEREFORE, EACH PARTY KNOWINGLY, INTENTIONALLY, IRREVOCABLY AND UNCONDITIONALLY WAIVES ANY RIGHT SUCH PARTY MAY HAVE HAD TO A TRIAL BY JURY IN RESPECT OF ANY SUCH DISPUTE.\n\n" +
"NOTWITHSTANDING THE FOREGOING, IN NO EVENT SHALL SPNDAT BE LIABLE TO OWNER FOR ANY MONETARY DAMAGES GREATER THAN THE AMOUNT ACTUALLY EARNED BY OWNER, INCLUSIVE OF DAMAGES, ATTORNEY’S FEES AND COSTS, IF APPLICABLE, FOR ANY CAUSE AND REGARDLESS OF THE FORM OF THE ACTION TAKEN.\n\n" +

"10. Dispute Resolution. Except to the extent that any applicable additional terms incorporated into these Terms provide differently or the applicable laws and regulation of your jurisdiction mandate otherwise, use of the App and/or Service and these Terms shall be governed by and construed in accordance with the laws of Tennessee.\n\n" +
"Any dispute, controversy or difference of opinion arising out of or in connection with the Agreement which cannot be settled amicably by parties to the Agreement (each a \"Claim\" and collectively \"Claims\"), including any question as to the validity, existence or termination of these Terms of Use and/or this Section 18, shall be referred to and finally resolved by arbitration under the Commercial Arbitration Rules (the \"AAA Rules\") of the American Arbitration Association (\"AAA\") in effect at the time the arbitration is initiated and modified by the terms set forth in this Arbitration Agreement and, where appropriate, the AAA’s Supplementary Procedures for Consumer Related Disputes (\"AAA Consumer Rules\"), both of which are available at the AAA website www.adr.org or by calling the AAA at 1-800-778-7879. Notwithstanding the foregoing, if requested by you and if proper based on the facts and circumstances of the Claims presented, the arbitrator will have the discretion to select a different set of AAA Rules, but in no event will the arbitrator consolidate more than one person’s Claims, or otherwise preside over any form of representative, collective, or class proceeding.\n\n" +

"11. Arbitration. To expedite resolution and reduce the cost of any Claim, you and SPNDAT agree to first attempt to negotiate any Claim (except those Claims expressly excluded below) informally for at least thirty (30) days before initiating any arbitration or court proceeding. Such informal negotiations will commence upon written notice. If necessary to preserve a Claim under any applicable statute of limitations, you or SPNDAT may initiate arbitration while engaging in the informal negotiations.\n\n" +
"YOU AND SPNDAT MUTUALLY AGREE TO WAIVE YOUR RESPECTIVE RIGHTS TO RESOLUTION OF ALL CLAIMS BETWEEN YOU (EXCEPT THOSE EXPRESSLY EXCLUDED BELOW) IN A COURT OF LAW BY A JUDGE OR JURY AND AGREE TO RESOLVE ANY DISPUTES BY BINDING ARBITRATION ON AN INDIVIDUAL BASIS AS SET FORTH HEREIN.\n\n" +
"This agreement to arbitrate, contained in this Section (this \"Arbitration Agreement\"), is governed by the Federal Arbitration Act and survives the termination of the Agreement or your relationship with SPNDAT. Claims include, but are not limited to, any dispute, claim or controversy whether based on past, present or future events arising out of or relating to: the Agreement and prior versions (including the breach, termination, enforcement, interpretation or validity thereof), the App and/or Service, your relationship with SPNDAT, the threatened or actual suspension, deactivation or termination of your Account or the Agreement, payments made by you or any payments made or allegedly owed to you, fraud, defamation, trade secrets, unfair competition, emotional distress, any promotions, offers made by SPNDAT, breach of any express or implied contract or covenant, claims arising under federal or state consumer protection laws; claims arising under antitrust laws, claims arising under the Telephone Consumer Protection Act and Fair Credit Reporting Act; and claims arising under the Civil Rights Act of 1964, Uniform Trade Secrets Act, Americans With Disabilities Act), and state statutes, if any, addressing the same or similar subject matters, and all other federal and state statutory and common law claims. All disputes concerning the arbitrability of a Claim (including Claims about the scope, applicability, enforceability, revocability or validity of the Arbitration Agreement) will be decided by the arbitrator, except as expressly provided below.\n\n" +
"YOU ACKNOWLEDGE AND UNDERSTAND THAT YOU AND SPNDAT ARE WAIVING THE RIGHT TO SUE IN COURT OR HAVE A JURY TRIAL FOR ALL CLAIMS, EXCEPT AS EXPRESSLY OTHERWISE PROVIDED IN THIS ARBITRATION AGREEMENT. THIS ARBITRATION AGREEMENT IS INTENDED TO REQUIRE ARBITRATION OF EVERY CLAIM OR DISPUTE THAT CAN LAWFULLY BE ARBITRATED EXCEPT THOSE CLAIMS AND DISPUTES WHICH BY TERMS OF THIS ARBITRATION AGREEMENT ARE EXPRESSLY EXCLUDED FROM THE REQUIREMENT TO ARBITRATE.\n\n" +

"12. Class Actions. You and SPNDAT agree that any arbitration will be limited to the Claim between SPNDAT and you individually. YOU ACKNOWLEDGE AND AGREE THAT YOU AND SPNDAT ARE EACH WAIVING THE RIGHT TO PARTICIPATE AS A PLAINTIFF OR CLASS MEMBER IN ANY PURPORTED CLASS ACTION OR REPRESENTATIVE PROCEEDING (\"CLASS ACTION WAIVER\"). Further, unless both you and SPNDAT otherwise agree, the arbitrator may not consolidate more than one person’s claims and may not otherwise preside over any form of any class or representative proceeding. The arbitrator will have no authority to consider or resolve any Claim or issue any relief on any basis other than an individual basis. The arbitrator will have no authority to consider or resolve any Claim or issue any relief on a class, collective, or representative basis.\n\n" +
"Notwithstanding any other provision of the Agreement, this Arbitration Agreement or the AAA Rules, disputes regarding the scope, applicability, enforceability, revocability or validity of the Class Action Waiver may be resolved only by a civil court of competent jurisdiction and not by an arbitrator. In any case in which: (1) the Claim is filed as a class, collective, or representative action and (2) there is a final judicial determination that the Class Action Waiver is unenforceable as to any Claims, the class, collective, and/or representative action on such Claims must be litigated in a civil court of competent jurisdiction, but the Class Action Waiver will be enforced in arbitration on an individual basis as to all other Claims to the fullest extent possible.\n\n" +

"13. Arbitration Fees. The arbitrator will decide the substance of all Claims in accordance with applicable law and will honor all claims of privilege recognized by law. The arbitrator will not be bound by rulings in prior arbitrations involving different third parties but is bound by rulings in prior arbitrations involving the same party to the extent required by applicable law. The arbitrator’s award will be final and binding and judgment on the award rendered by the arbitrator may be entered in any court having jurisdiction thereof, provided that any award may be challenged in a court of competent jurisdiction in accordance with the Federal Arbitration Act. Your arbitration fees and your share of arbitrator compensation will be governed by the AAA Rules (and, where appropriate, limited by the AAA Consumer Rules) subject to the following modifications:\n" +
"   • If SPNDAT initiates arbitration under this Arbitration Agreement, SPNDAT will pay all AAA filing and arbitration fees. If you file a Claim in accordance with this Arbitration Agreement, you will pay all such fees unless the arbitrator finds that either the substance of your Claim or the relief sought in your Demand for Arbitration was frivolous or was brought for an improper purpose (as measured by the standards set forth in Federal Rule of Civil Procedure 11(b)).\n" +
"   • For Claims that arise out of, or relate to, SPNDAT’s actual or threatened deactivation of your Account or arise out of, or relate to SPNDAT’s actual or threatened termination of the Agreement with SPNDAT, if you are the party initiating such Claim, you will be responsible for contributing up to an amount equal to the filing fee that would be paid to initiate the claim in the court of general jurisdiction in the state in which you reside, unless a lower fee amount would be owed by you pursuant to the AAA Rules or applicable law. Any dispute as to whether a cost is unique to arbitration will be resolved by the arbitrator.\n" +
"   • Except as provided in Federal Rule of Civil Procedure 68 or any state equivalents, each party will pay its own attorneys’ fees and pay any costs that are not unique to the arbitration (i.e., costs that each party would incur if the Claim(s) were litigated in a court, such as costs to subpoena witnesses and/or documents, take depositions and purchase deposition transcripts, copy documents, etc.).\n" +
"   • At the conclusion of any arbitration, the arbitrator may award reasonable fees and costs or any portion thereof to you if you prevail, to the extent authorized by applicable law. Unless you and SPNDAT agree otherwise, the seat of the arbitration shall be the State of Tennessee and any hearings between SPNDAT and you will take place in the State of Tennessee.\n\n" +

"14. Claims Excluded. The following types of Claims are not required to be arbitrated under this Arbitration Agreement (\"Excluded Claims\"):\n" +
"   • Small claims actions that are within the scope of small claims court jurisdiction and brought on an individual basis; and\n" +
"   • Claims that may not be subject to arbitration as a matter of law.\n\n" +
"Nothing in this Arbitration Agreement prevents you from making a report to or filing a claim or charge with the Equal Employment Opportunity Commission, U.S. Department of Labor, Securities Exchange Commission, National Labor Relations Board, or Office of Federal Contract Compliance Programs, or similar local, state or federal agency, and nothing in this Arbitration Agreement will be deemed to preclude or excuse a party from bringing an administrative claim before any agency in order to fulfil the party’s obligation to exhaust administrative remedies before making a claim in arbitration. However, you knowingly and voluntarily waive the right to seek or recover money damages of any type pursuant to any administrative complaint and instead may seek such relief only through arbitration under the Agreement. The Agreement and this Arbitration Agreement do not prevent you from participating in an investigation by a government agency of any report, claim or charge otherwise covered by this arbitration provision and do not prevent you from receiving an award for information provided to any government agencies. In addition to the severability and survival provisions set forth herein, in the event that any portion of this Arbitration Agreement is deemed illegal or unenforceable, such provision will be severed and the remainder of this Arbitration Agreement will be given full force and effect. The arbitrator, and not any court, shall have exclusive authority to resolve all issues, including the scope, applicability, interpretation and enforcement of this arbitration provision (including any claims of unconscionability or that this provision is void or voidable).\n\n" +

"15. Miscellaneous:\n" +
"   a. Doxing Protocol. “Doxing” shall include, but not be limited to, the following: publicly providing personally identifiable information about an individual or organization, via the Internet and without their consent. Anyone who attempts to dox another user or display another user's personally identifiable information without their consent will be terminated immediately without notice.\n" +
"   b. Breach and Waiver. A waiver of any breach of these Terms in any one instance will not constitute a waiver of any subsequent breach, whether or not similar.\n" +
"   c. Taxes. You shall be solely responsible for and pay your tax obligations.\n" +
"   d. Severance. In the event of any conflict between any provision of these Terms and any present or future statute, law, ordinance or regulation, the latter will prevail, but in such event, the provision of these Terms affected will be severed and limited only to the extent necessary to bring it within legal requirements.\n" +
"   e. Assignment. We may fully and freely transfer, designate, assign, and license, in whole or in part, without restriction, the Rights granted to us under these Terms. Neither these Terms nor any of your rights or responsibilities under these Terms may be assigned or otherwise transferred by you without our prior written consent.\n\n" +

"16. Contact Us. If you have any questions about these Terms, please contact us at support@spndat.com. Write to us at:\n" +
"SPNDAT Inc.\n" +
"2025 S McCall Road,\n" +
"Englewood, FL 34223\n";


  const options = [
    { label: 'Personal', value: 'Fan' },
    { label: 'Artist', value: 'Artist' },
    { label: 'Band', value: 'Band' },
    { label: 'Record Label', value: 'RecordLabel' },
    { label: 'Producer', value: 'Producer' },
    { label: 'Songwriter', value: 'Songwriter' },
    { label: 'SPNCaster', value: 'SPNCaster' },
    { label: 'Filmmaker', value: 'Filmmaker' },
    { label: 'Director', value: 'Director' },
    { label: 'Actor', value: 'Actor' },
  ];

  return (
    <>
      <div style={styles.container}>
        <div style={styles.form}>
          <h1 style={styles.title}>Sign Up</h1>
          <input
            style={styles.input}
            type="email"
            placeholder="Email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
          <input
            style={styles.input}
            ref={passwordRef}
            type="password"
            placeholder="Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
          <input
            style={styles.input}
            ref={confirmPasswordRef}
            type="password"
            placeholder="Confirm Password"
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
          />
          <input
            style={styles.input}
            type="text"
            placeholder={namePlaceholder}
            value={name}
            onChange={(e) => setName(e.target.value.replace(/[^a-zA-Z0-9\s]/g, '').substring(0, 30))}
          />
          {accountType === 'Artist' && (
            <p style={styles.smallText}>This Artist Name will be what is displayed on your content releases and cannot be changed</p>
          )}
          <input
            style={styles.input}
            type="text"
            placeholder="@Username"
            value={username}
            onChange={(e) => setUsername(e.target.value.replace(/[^a-zA-Z0-9]/g, '').substring(0, 25))}
          />
          <input
            style={styles.input}
            type="text"
            placeholder="City"
            value={location}
            onChange={(e) => setLocation(e.target.value.substring(0, 17))}
          />
          <Select
            onChange={(option) => setCountry(option.value)}
            options={countryList}
            placeholder="Select your country (optional)..."
            value={countryList.find(option => option.value === country)}
          />
          {country === 'US' && (
            <Select
              onChange={(option) => setSelectedState(option.value)}
              options={statesList}
              placeholder="Select your state (optional)..."
              value={statesList.find(option => option.value === selectedState)}
            />
          )}
          <label style={styles.label}>Account Type:</label>
          <Select
            onChange={(option) => setAccountType(option.value)}
            options={options}
            value={options.find(option => option.value === accountType)} 
            placeholder="Select an account type..."
          />
          {validationError && <p style={styles.error}>{validationError}</p>}
          <CustomButton
            title="Create Account"
            onClick={handleSignupPress}
            textStyle={{ color: '#FFF' }}
            buttonStyle={{ borderColor: '#62fbfa', borderWidth: 2, marginBottom: 16, marginTop: 16, backgroundColor: 'transparent', }}
          />
          <p style={styles.switchText}>
            Already have an account?{" "}
            <span style={styles.switchButton} onClick={() => navigate('/login')}>
              Login
            </span>
          </p>
        </div>
      </div>
      {termsModalVisible && (
  <div style={styles.centeredView}>
    <div style={styles.modalView}>
      <div style={styles.scrollView}>
        <p style={styles.modalText}>{DISPLAY_TEXT}</p>
      </div>
      <div style={styles.checkboxContainer}>
        <CustomCheckbox isChecked={termsAccepted} onCheck={() => setTermsAccepted(!termsAccepted)} />
        <p style={{ marginLeft: 8, color: 'white' }}>I agree to the Privacy Policy, Terms and Conditions</p>
      </div>
      <button
        style={styles.buttonClose}
        onClick={() => {
          setTermsModalVisible(!termsModalVisible);
          handleAgreeAndCreateAccount();
        }}
      >
        Agree and Create Account
      </button>
      <button
        style={styles.buttonClose}
        onClick={() => setTermsModalVisible(!termsModalVisible)}
      >
        Close
      </button>
    </div>
  </div>
)}

{showVerifyPrompt && (
  <div style={styles.verifyBanner}>
    📬 We’ve sent a verification link to {email}.  
    Please check your inbox and click the link before you log in.
  </div>
)}

    </>
  );
};

const styles = {
  container: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100vh',
    backgroundColor: '#0e061e',
    transform: 'translateY(-150px)', // Moves the container up by 50px
  },
  form: {
    width: '80%',
    maxWidth: '400px',
    backgroundColor: '#0e061e',
    padding: '20px',
    borderRadius: '10px',

  },
  title: {
    fontSize: '2rem',
    fontWeight: 'bold',
    marginBottom: '20px',
    color: '#fff',
  },
  input: {
    width: '100%',
    height: '40px',
    borderColor: '#ddd',
    borderWidth: '1px',
    marginBottom: '10px',
    padding: '8px',
    fontSize: '1rem',
    color: '#fff',
    backgroundColor: 'rgba(255,255,255,0.2)',
    borderRadius: '5px',
  },
  label: {
    alignSelf: 'flex-start',
    marginBottom: '5px',
    marginTop: '5px',
    color: '#fff',
  },
  smallText: {
    color: 'rgba(255, 255, 255, 0.7)',
    fontSize: '0.8rem',
    marginTop: '5px',
    marginBottom: '10px',
    textAlign: 'center',
  },
  error: {
    color: 'red',
    marginBottom: '10px',
  },
  switchText: {
    marginTop: '10px',
    color: '#fff',
  },
  switchButton: {
    color: '#62fbfa',
    fontWeight: 'bold',
    textDecoration: 'underline',
    cursor: 'pointer',
  },
  customButton: {
    padding: '10px',
    borderRadius: '5px',
    textAlign: 'center',
    justifyContent: 'center',
    width: '100%',
    cursor: 'pointer',
  },
  customButtonText: {
    fontSize: '1rem',
    color: '#FFF',
  },
  centeredView: {
    position: 'fixed',
    overflow: 'hidden',
    top: '0',
    left: '0',
    width: '100%',
    height: '100%',
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'column',
    alignItems: 'center',
    backgroundColor: 'rgba(0,0,0,0.5)',
  },
  modalView: {
    width: '80%',
    maxWidth: '500px',
    maxHeight: '80vh',
    backgroundColor: 'black',
    borderRadius: '20px',
    padding: '20px',
    textAlign: 'center',
    boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.5)',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  scrollView: {
    maxHeight: '60vh',
    overflowY: 'auto',
    marginBottom: '20px',
    padding: '10px',
    border: '1px solid #ddd',
    borderRadius: '5px',
    width: '100%',
    color: 'white',
  },
  modalText: {
    color: 'white',
    textAlign: 'left',
    whiteSpace: 'pre-wrap',
  },
  checkboxContainer: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: '20px',
  },
  checkboxBase: {
    width: '24px',
    height: '24px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    border: '2px solid white',
    borderWidth: '2px',
    borderColor: 'white',
    borderRadius: '4px',
    cursor: 'pointer',
  },
  checkboxChecked: {
    width: '12px',
    height: '12px',
    backgroundColor: 'white',
  },
  buttonClose: {
    backgroundColor: 'transparent',
    borderRadius: '20px',
    padding: '10px',
    marginTop: '10px',
    cursor: 'pointer',
    color: '#62fbfa',
    fontSize: '18px',
    border: 'none',
    width: '100%',
  },
};

export default SignupScreen;
